import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import CediCartePage from '../../../pages/Cards/CediCartePage';
import CediCarteMobile from '../../../pages/Mobile/Cards/CediCarteMobile';

const CediCarteResponsive: React.FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <CediCarteMobile /> : <CediCartePage />;
};

export default CediCarteResponsive;
